import { render, staticRenderFns } from "./MarketingToolModal.vue?vue&type=template&id=8bfbde20&"
import script from "./MarketingToolModal.vue?vue&type=script&lang=js&"
export * from "./MarketingToolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports